import React from "react";
// import {
//   Dashboard
// } from "../../_metronic/_partials";
import { Audit } from "../../_metronic/_partials/audits/Audit";

export function AuditPage() {
  return <Audit />;
}
